import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class DriverAnnualRideExecutionData extends AbstractModel {
  @autoserialize
  driverId: number;

  @autoserialize
  id: number;

  @autoserialize
  taxDocumentsAvailable: boolean;

  @autoserialize
  totalEarnings: number;

  @autoserialize
  totalP1Distance: number;

  @autoserialize
  totalP2Distance: number;

  @autoserialize
  totalP3Distance: number;

  @autoserialize
  year: number;
}
